import React, { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";

/**
 * Counts up to `value` when scrolled into view.
 * Falls back to rendering `value` as-is if it is not a finite number.
 */
export function AnimatedCounter({ value, prefix = "", suffix = "", decimals = 0, duration = 1.6, className = "" }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.5 });
  const [display, setDisplay] = useState(0);
  const numeric = typeof value === "number" && isFinite(value);

  useEffect(() => {
    if (!inView || !numeric) return;
    let raf;
    let start = null;
    const step = (t) => {
      if (start === null) start = t;
      const progress = Math.min((t - start) / (duration * 1000), 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      setDisplay(value * eased);
      if (progress < 1) raf = requestAnimationFrame(step);
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [inView, value, duration, numeric]);

  return (
    <span ref={ref} className={className}>
      {numeric ? `${prefix}${display.toFixed(decimals)}${suffix}` : value}
    </span>
  );
}
